import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import PrimaryDropdown from "../../../../../parts/primary-dropdown";
import { milestoneLabel } from "../../../../../utils/annual-planner-helpers";
import { openModal } from "../../../../../utils/modal-helpers";
import { MilestoneKindIcon } from "./MilestoneKindIcon";

// Milestone name rows - the label-column content for the Milestone row-
// group's [label|body] pair in CalendarView's .planner-grid. The chevron/
// title bar above this (always visible, even while these rows are hidden by
// collapse) is its own full-width row (PlannerTitleRow.js) - see that file's
// comment for why they're split. See
// ~/.claude/plans/periodization-calendar-view-redesign.md Fase 2/5.
//
// The "+Add" button at the bottom is a PrimaryDropdown, not a plain button
// like PhaseRowHeader's "+Add Training/Nutrition Phase" - unlike a phase,
// "milestone" isn't one creatable thing, it's 2 (event vs goal), so it needs
// the same hover-opens/click-picks menu Header.js's own "+Add" already uses
// for these same 2 entries, not a single direct modal open.
const ADD_MILESTONE_OPTIONS_KEYS = {
  event: "annualPlanner.event",
  goal: "annualPlanner.goal",
};

export const MilestoneRowHeader = ({ milestones, events }) => {
  const { t } = useTranslation(["athlete-portal", "common"]);

  const addMenuOptions = Object.entries(ADD_MILESTONE_OPTIONS_KEYS).map(
    ([value, translationKey]) => ({ label: t(translationKey), value })
  );

  const handleAddSelect = (value) => {
    if (value === "event") return openModal("add-event");
    if (value === "goal") return openModal("manage-milestone-goals");
  };

  const openMilestone = (milestone) => {
    if (milestone.kind === "event") {
      const event = (events || []).find((e) => e._id === milestone.id);
      if (!event) return;
      submit("/actions/refresh", {
        method: "GET",
        body: {
          "modal[type]": "individual-event",
          eventName: event.name,
          eventDescription: event.description,
          eventFromDate: event.fromDate,
          eventToDate: event.toDate || "",
          eventColor: event.eventColor,
          eventId: event._id,
        },
      });
      return;
    }
    // bodyWeight/personalRecord goals share the same edit modal ClientGoals.js
    // itself opens - modalState picks the right form, goalId loads the goal.
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "add-client-goal",
        modalState: milestone.kind,
        goalId: milestone.id,
      },
    });
  };

  return (
    <div className="milestones-row-header">
      {milestones.map((milestone, index) => (
        <div // NOSONAR
          className="event-name-label-wrapper"
          key={`milestone-name-label-${milestone.kind}-${index}`}
          onClick={() => openMilestone(milestone)}
        >
          <MilestoneKindIcon kind={milestone.kind} />
          <span
            className="event-name-label-text"
            title={milestoneLabel(milestone, t)}
          >
            {milestoneLabel(milestone, t)}
          </span>
        </div>
      ))}
      <PrimaryDropdown
        summaryText={t("common:add")}
        options={addMenuOptions}
        onSelectFn={handleAddSelect}
        alignRight
        gradientIcon
      />
    </div>
  );
};
